<template>
  <div>
    <v-alert color="red darken-1" v-if="!loading && !isDomainVerified" dark border="left" icon="mdi-alert" prominent dense>
      <div class="d-flex align-center">
        <strong>Você ainda não verificou o seu domínio. Por favor, verifique-o para poder utilizar o seu pixel!</strong>
        <v-spacer></v-spacer>
        <v-btn text dark @click="$router.push('/dominios')">Verificar agora</v-btn>
      </div>
    </v-alert>
    <v-btn
      color="#803BE8"
      large
      fixed
      depressed
      fab
      dark
      bottom
      right
      @click="newLink = true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <zp-link-performance v-model="linkPerformance"></zp-link-performance>
    <zp-new-link v-model="newLink"></zp-new-link>
    <zp-update-link v-if="updateLink" v-model="updateLink"></zp-update-link>
    <zp-test-link v-model="testLink" :url="testLinkUrl"></zp-test-link>

    <div v-if="loading && !links.length" style="height: 100%;" class="d-flex flex-column justify-center align-center">
      <v-progress-circular
        :width="3"
        :size="60"
        color="blue"
        indeterminate
      ></v-progress-circular>
      <strong class="mt-5">Carregando links...</strong>
    </div>
    <zp-links-empty v-else-if="!links.length"></zp-links-empty>
    <template v-else>
      <div>Links do projeto</div>
      <v-card flat class="mt-2">
        <v-toolbar flat>
          <v-text-field
            outlined
            dense
            hide-details
            placeholder="Pesquisar"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            style="max-width: 400px;"
          ></v-text-field>
          <v-spacer></v-spacer>

          <div v-if="advancedSeries" style="width: 230px;" class="mr-3 d-flex align-center">
            <zp-date-range-picker label="Período customizado" style="cursor: pointer" placeholder="Selecione" v-model="period" clearable hide-details></zp-date-range-picker>
          </div>
          <div style="width: 240px;" class="mr-3" v-else>
            <v-select
              outlined
              dense
              :loading="loading"
              prepend-inner-icon="mdi-calendar"
              placeholder="Todo período"
              v-model="days"
              :items="periods"
              clearable
              hide-details
            >
              <template v-slot:item="{ item }">
                <div class="caption d-flex flex-column pb-1 pt-1">
                  <span class="font-weight-bold">{{item.text}}</span>
                  <span>{{item.description}}</span>
                </div>
              </template>
            </v-select>
          </div>

          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" icon class="mr-1" @click="exportToCsv()">
                <v-icon>mdi-tray-arrow-down</v-icon>
              </v-btn>
            </template>
            <span>Exportar CSV</span>
          </v-tooltip>

          <v-btn icon @click="index()">
            <v-icon>mdi-autorenew</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-data-table
        class="mt-3"
        :headers="headers"
        :items="items"
        :loading="loading"
        sort-by="created_at"
        :no-data-text="period.length === 2 ? 'Não há links criados neste período.' : 'Links não encontrados.'"
        :footer-props="{
          itemsPerPageText: 'Links por página:'
        }"
      >
        <template v-slot:header.clicks="{}">
          <span>Cliques</span>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-1" color="grey" dark v-bind="attrs" v-on="on" x-small>
                mdi-information
              </v-icon>
            </template>
            <span>Últimos 7 dias</span>
          </v-tooltip>
        </template>
        <template v-slot:item.created_at="{ item }">
          <span>{{item.created_at | datetime}}</span>
        </template>
        <template v-slot:item.mode="{ item }">
          <div class="d-flex align-center">
            <img v-if="item.url.indexOf('https://t.me') === 0" src="/img/telegram.svg" style="width: 20px;" alt="Telegram">
            <img v-else-if="item.url.indexOf('https://wa.me') === 0" src="/img/wpp.svg" style="width: 22px;" alt="WhatsApp">
            <img v-else-if="item.url.indexOf('tel:') === 0" src="/img/phone.svg" style="width: 22px;" alt="Telefone">
            <img v-else-if="item.url.indexOf('https://m.me') === 0" src="/img/messenger.svg" style="width: 20px;" alt="Messenger">
            <img v-else-if="item.url.indexOf('mailto:') === 0"  src="/img/email.svg" style="width: 20px;" alt="Email">
            <img v-else-if="item.url.indexOf('ifood.com.br') > -1"  src="/img/ifood.svg" style="width: 20px;" alt="Email">
            <img v-else src="/img/link.svg" style="width: 24px;" alt="Link">
            <span class="ml-2">
              <span v-if="item.mode === 'direct'">Redirecionamento</span>
              <span v-else>Mini página</span>
            </span>
          </div>
        </template>
        <template v-slot:item.clicks="{ item }">
          <span>{{item.clicks | number}}</span>
        </template>
        <template v-slot:item.last_click="{ item }">
          <span v-if="item.last_click">{{item.last_click | datetime}}</span>
          <span v-else class="font-italic grey--text">Não há</span>
        </template>
        <template v-slot:item.name="{ item }">
          <strong>{{item.name}}</strong>
        </template>
        <template v-slot:item.pixels="{ item }">
          <div class="d-flex" v-if="(item.pixels || []).length">
            <v-tooltip left v-for="(_item, index) in item.pixels" :key="index">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-img v-if="_item.type === 'Facebook Pixel'" src="/img/fb.svg" style="width: 20px" class="mr-1"></v-img>
                  <v-img v-else-if="_item.type === 'Google Analytics'" src="/img/ga.svg" style="width: 20px" class="mr-1"></v-img>
                  <v-img v-else-if="_item.type === 'Google Tag Manager'" src="/img/gtm.svg" style="width: 20px" class="mr-1"></v-img>
                </span>
              </template>
              <div class="d-flex flex-column pt-2 pb-2" style="line-height: 1.1">
                <span class="caption">{{_item.type}}</span>
                <span class="font-weight-bold">{{_item.name}}</span>
              </div>
            </v-tooltip>
          </div>
          <span v-else class="font-weight-light">Não há</span>
        </template>
        <template v-slot:item.shortened="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <a v-bind="attrs" v-on="on" style="text-decoration: none;" class="blue--text" @click="copyStringToClipboard(`https://${item.domain ? item.domain.name : 'zprs.in'}/${item.shortened}`)">
                /{{item.shortened}} <v-icon x-small>mdi-content-copy</v-icon>
              </a>
            </template>
            <span>{{`https://${item.domain ? item.domain.name : 'zprs.in'}/${item.shortened}`}}</span> <span class="caption">(Clique para copiar)</span>
          </v-tooltip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark :color="isActivePlan ? 'black' : 'grey lighten-1'" v-bind="attrs" v-on="on" icon @click="isActivePlan && openInNewTabTest(item)" class="mr-1">
                <v-icon small>mdi-test-tube</v-icon>
              </v-btn>
            </template>
            <span>Testar link <span class="font-weight-bold" v-if="!isActivePlan">(Contrate um de nossos planos para utilizar)</span></span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small :color="isActivePlan ? 'black' : 'grey lighten-1'" v-bind="attrs" v-on="on" icon @click="isActivePlan && openUTMBuilder({ name: item.name, url: `https://${item.domain ? item.domain.name : 'zprs.in'}/${item.shortened}` })" class="mr-1">
                <v-icon small>mdi-radar</v-icon>
              </v-btn>
            </template>
            <span>UTM Builder <span class="font-weight-bold" v-if="!isActivePlan">(Contrate um de nossos planos para utilizar)</span></span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark color="black" v-bind="attrs" v-on="on" icon @click="duplicate(item)" :loading="loadingDuplicate[item.id]" class="mr-1">
                <v-icon small>mdi-content-duplicate</v-icon>
              </v-btn>
            </template>
            <span>Duplicar link</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark :color="isActivePlan ? 'black' : 'grey lighten-1'" v-bind="attrs" v-on="on" icon @click="isActivePlan && (linkPerformance = item)" class="mr-1">
                <v-icon small>mdi-poll</v-icon>
              </v-btn>
            </template>
            <span>Desempenho do link <span class="font-weight-bold" v-if="!isActivePlan">(Contrate um de nossos planos para utilizar)</span></span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark :color="isActivePlan ? 'black' : 'grey lighten-1'" v-bind="attrs" v-on="on" icon @click="isActivePlan && openQRCode({ name: item.name, url: `https://${item.domain ? item.domain.name : 'zprs.in'}/${item.shortened}` })" class="mr-1">
                <v-icon small>mdi-qrcode</v-icon>
              </v-btn>
            </template>
            <span>Gerar QRCode <span class="font-weight-bold" v-if="!isActivePlan">(Contrate um de nossos planos para utilizar)</span></span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark color="black" v-bind="attrs" v-on="on" icon @click="updateLink = item">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar link</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <zp-modal-upgrade v-model="upgrade" type="plan"></zp-modal-upgrade>

    <zp-alert-modal v-model="modalDuplicate" icon="/img/alert/duplicate-link.svg" @ok="duplicate()" cancel>
      <div class="d-flex flex-column">
        <h3>Por favor, confirme a sua ação:</h3>
        <span class="mt-2">Você tem certeza que desejar gerar uma cópia deste link?</span>
      </div>
    </zp-alert-modal>

    <zp-alert-modal v-model="modalPermission" icon="/img/alert/access-denied.svg" @ok="modalPermission = false">
      <div class="d-flex flex-column">
        <span>Você não possui permissão para realizar esta ação.</span>
      </div>
    </zp-alert-modal>

    <zp-qr-code v-if="qrcode.dialog" v-model="qrcode.dialog" :url="qrcode.url" :name="qrcode.name"></zp-qr-code>
    <zp-utm-builder v-model="utmBuilder.dialog" :url="utmBuilder.url" :name="utmBuilder.name"></zp-utm-builder>

    <v-snackbar v-model="copied" :timeout="2000">
      Link copiado para área de transferência
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" small text v-bind="attrs" @click="copied = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { nanoid } from 'nanoid'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

import ZpLinksEmpty from '../components/EmptyLinks'
import ZpNewLink from '../components/NewLink'
import ZpUpdateLink from '../components/UpdateLink'
import ZpLinkPerformance from '../components/LinkPerformance'
import ZpTestLink from '@/components/TestLink'
import ZpModalUpgrade from '@/components/ModalUpgrade'
import ZpAlertModal from '@/components/AlertModal.vue'
import ZpQrCode from '@/components/QRCode.vue'
import ZpUtmBuilder from '@/components/UTMBuilder.vue'
import ZpDateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    ZpLinksEmpty,
    ZpNewLink,
    ZpUpdateLink,
    ZpLinkPerformance,
    ZpTestLink,
    ZpModalUpgrade,
    ZpAlertModal,
    ZpQrCode,
    ZpDateRangePicker,
    ZpUtmBuilder
  },
  data () {
    return {
      newLink: false,
      updateLink: null,
      testLink: false,
      testLinkUrl: '',
      linkPerformance: null,
      loadingDuplicate: {},
      days: null,
      advancedSeries: false,
      modalDuplicate: false,
      modalPermission: false,
      duplicateItem: null,
      search: '',
      loading: true,
      copied: false,
      upgrade: false,
      qrcode: {
        dialog: false,
        name: false,
        url: null
      },
      utmBuilder: {
        dialog: false,
        name: false,
        url: null
      },
      period: [],
      headers: [{
        text: 'Data de criação',
        value: 'created_at'
      }, {
        text: 'Tipo de link',
        value: 'mode'
      }, {
        text: 'Nome',
        value: 'name'
      }, {
        text: 'Link final',
        value: 'shortened'
      }, {
        text: 'Cliques',
        value: 'clicks'
      }, {
        text: 'Último clique',
        value: 'last_click'
      }, {
        text: 'Pixel(s)',
        value: 'pixels'
      }, {
        text: 'Ação',
        value: 'action'
      }]
    }
  },
  computed: {
    ...mapState({
      projectId: state => state.projects.id,
      links: state => state.links.data,
      domains: state => state.domains.data,
      user: state => state.auth.user
    }),
    ...mapGetters({
      project: 'projects/getSelected'
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now() || this.project.user_id !== this.user.id
    },
    periods () {
      const periods = [{
        text: 'Hoje',
        description: moment().format('DD/MM/YY'),
        value: 'today'
      }, {
        text: 'Ontem',
        description: moment().subtract(1, 'days').format('DD/MM/YY'),
        value: 'yersteday'
      }, {
        text: 'Últimos 7 dias',
        description: `${moment().subtract(7, 'days').format('DD/MM/YY')} - ${moment().format('DD/MM/YY')}`,
        value: 7
      }, {
        text: 'Últimos 30 dias',
        description: `${moment().subtract(30, 'days').format('DD/MM/YY')} - ${moment().format('DD/MM/YY')}`,
        value: 30
      }, {
        text: 'Esta semana',
        description: `${moment().weekday(0).format('DD/MM/YY')} - ${moment().weekday(7).format('DD/MM/YY')}`,
        value: 'week'
      }, {
        text: 'Este mês',
        description: `${moment().format('[01]/MM/YY')} - ` + moment().format(`[${moment().daysInMonth()}]/MM/YY`),
        value: 'month'
      }, {
        value: -1,
        text: 'Customizado'
      }]

      return periods
    },
    items () {
      return this.links.filter(item => {
        let filtered = true

        if (this.period.length === 2) {
          filtered = moment(item.created_at).isAfter(this.period[0]) && moment(item.created_at).isBefore(this.period[1])
        }

        if (filtered && this.search) {
          filtered = new RegExp(this.search, 'i').test(item.name) ||
            new RegExp(this.search, 'i').test(item.domain ? item.domain.name : '') ||
            new RegExp(this.search, 'i').test(item.url) ||
            new RegExp(this.search, 'i').test(item.shortened) ||
            new RegExp(this.search, 'i').test(item.pixel_event) ||
            new RegExp(this.search, 'i').test(item.pixel_id) ||
            new RegExp(this.search, 'i').test(item.url)
        }

        return filtered
      }).map(link => {
        return {
          ...link,
          clicks: (link.__meta__ || {}).clicks_count
        }
      })
    },
    isDomainVerified () {
      return !!this.domains.find(item => item.verified)
    }
  },
  watch: {
    projectId: {
      immediate: true,
      handler: async function (projectId) {
        if (projectId) {
          this.index(projectId)
        }
      }
    },
    days: function (days) {
      if (days === -1) {
        this.advancedSeries = true
        this.period = [
          moment(moment().format('YYYY-MM-[01]')).toISOString(),
          moment(moment().format(`YYYY-MM-[${moment().daysInMonth()}]`)).toISOString()
        ]
      } else if (days === 'today') {
        this.period = [
          moment().toISOString(),
          moment().toISOString()
        ]
      } else if (days === 'yersteday') {
        this.period = [
          moment().subtract(1, 'days').toISOString(),
          moment().subtract(1, 'days').toISOString()
        ]
      } else if (days === 'week') {
        this.period = [
          moment().weekday(0).toISOString(),
          moment().weekday(7).toISOString()
        ]
      } else if (days === 'month') {
        this.period = [
          moment(moment().format('YYYY-MM-[01]')).toISOString(),
          moment(moment().format(`YYYY-MM-[${moment().daysInMonth()}]`)).toISOString()
        ]
      } else if (typeof days === 'number') {
        this.period = [
          moment().subtract(days, 'days').toISOString(),
          moment().toISOString()
        ]
      } else {
        this.period = []
      }
    },
    period: function (period) {
      if (!period.length) {
        this.days = null
        this.advancedSeries = false
      }
    }
  },
  methods: {
    async index (projectId = this.projectId) {
      this.loading = true
      this.$store.commit('domains/SET_DATA', [])
      this.$store.commit('pixels/SET_DATA', [])
      this.$store.commit('links/SET_DATA', [])
      await Promise.all([
        this.$store.dispatch('domains/index', { user_id: this.project.user_id }),
        this.$store.dispatch('pixels/index', { user_id: this.project.user_id }),
        this.$store.dispatch('links/index', projectId)
      ])
      this.loading = false
    },
    copyStringToClipboard (str) {
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
    },
    async duplicate (item) {
      if (item) {
        this.duplicateItem = item
        this.modalDuplicate = true
        return
      }

      this.loadingDuplicate = {
        ...this.loadingDuplicate,
        [this.duplicateItem.id]: true
      }

      try {
        await this.$store.dispatch('links/store', {
          project_id: this.projectId,
          data: {
            ...this.duplicateItem,
            name: `Cópia de ${this.duplicateItem.name}`,
            shortened: nanoid(6),
            pixels: this.duplicateItem.pixels.map(item => item.id)
          }
        })

        this.modalDuplicate = false
      } catch (e) {
        console.error(e)

        this.upgrade = e.message === 'Você já atingiu o limite de links permitidos no seu plano.'
        this.modalPermission = e.message === 'Você não possui permissão para realizar esta ação.'

        if (!this.upgrade) {
          alert(e.message)
        }
      }

      this.loadingDuplicate = {
        ...this.loadingDuplicate,
        [this.duplicateItem.id]: false
      }
    },
    openInNewTabTest (item) {
      this.testLink = true
      this.testLinkUrl = `https://${item.domain ? item.domain.name : 'zprs.in'}/${item.shortened}`
    },
    openQRCode ({ url, name }) {
      this.qrcode.url = url
      this.qrcode.dialog = true
      this.qrcode.name = name
    },
    openUTMBuilder ({ url, name }) {
      this.utmBuilder.url = url
      this.utmBuilder.dialog = true
      this.utmBuilder.name = name
    },
    exportToCsv () {
      const csv = [`"Projeto","Data de criação","Tipo de link","Nome","Link final","Cliques","Último clique","Pixels"`]

      this.items.forEach(item => {
        csv.push(`"${this.project.name}","${item.created_at}","${item.mode === 'preview' ? 'Mini página' : 'Redirecionamento'}","${item.name}","${`https://${item.domain ? item.domain.name : 'zprs.in'}/${item.shortened}`}","${item.clicks}","${item.last_click}","${item.pixels.map(item => item.name).join(',')}"`)
      })

      const blob = new Blob([csv.join('\n')], { type: 'text/csv;charset=utf-8;' })
      const filename = `links-${this.project.name.replace(/\s/g, '-')}-${moment().format('YYYY-MM-DD-HH-mm')}.csv`.toLowerCase()

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>